import React, { Component } from 'react';
import desktopLogo from '../../images/logos/desktop/INFLUENCElogo-blue.png';
import mobileLogo from '../../images/logos/mobile/MOBILElogo-blue.png';
import MainNav from './Nav/MainNav/';
import MobileNav from './Nav/MobileNav';

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  toggleMenu(){
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen
    }))
  }
  /**
   * Checks for break point
   */
  checkDimensions(){
    if(window.innerWidth > 768) {
      this.setState({menuOpen: false});
    }
  }
  /**
   * Sets event listener
   */
  componentDidMount() {
    this.checkDimensions();
    window.addEventListener("resize", this.checkDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.checkDimensions.bind(this));
  }

  render() {
    const{menuOpen} = this.state

    return (
      <header>
        <div className="container">
          <div className="row">
            <div className="main-nav-wrapper">
              <a className="desktop-logo" href="/"><img src={desktopLogo} alt="logo"/></a>
              <a className="mobile-logo" href="/"><img src={mobileLogo} alt="logo"/></a>
              < MainNav />
              <div className="menu-toggle" onClick={() => this.toggleMenu()} >
              {menuOpen
              ? <i className="fa fa-times" aria-hidden="true"></i>
              : <i className="fa fa-bars" aria-hidden="true"></i>
              }
              </div>
            </div>
            {menuOpen && < MobileNav />}

          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js